import request from '@/plugin/axios'

export function fetchTree (query) {
  return request({
    url: '/admin/syscompanylegal/list',
    method: 'get',
    params: query
  })
}
